<template>
  <!-- 디자인 시스템: 드롭다운 메뉴 (v-menu + v-list). items 선언형 기본 + 슬롯 자유배치.
       활성자 기본 = 더보기(⋮) 아이콘 버튼(activator 슬롯으로 교체 가능). 테마는 앱(vuetify) 따름(light prop으로 강제 가능). -->
  <v-menu offset-y :left="left" :close-on-content-click="closeOnClick" v-bind="$attrs">
    <template #activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>{{ activatorIcon }}</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-list :dense="dense" :dark="isDark" :light="!isDark" :min-width="minWidth">
      <slot>
        <v-list-item
          v-for="(it, i) in items"
          :key="it.value != null ? it.value : i"
          :disabled="it.disabled"
          @click="onSelect(it)"
        >
          <v-icon v-if="it.icon" small left :color="it.color">{{ it.icon }}</v-icon>
          <v-list-item-title :class="it.color ? `${it.color}--text` : ''">{{ it.label }}</v-list-item-title>
        </v-list-item>
      </slot>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "AppMenu",
  inheritAttrs: false, // 나머지 attr은 v-menu로 전달 (offset/nudge 등)
  props: {
    // [{ label, icon?, color?, value?, disabled? }] — 슬롯을 쓰면 무시됨
    items: { type: Array, default: () => [] },
    activatorIcon: { type: String, default: "mdi-dots-vertical" },
    left: { type: Boolean, default: true },
    dense: { type: Boolean, default: true },
    minWidth: { type: [Number, String], default: 160 },
    closeOnClick: { type: Boolean, default: true },
    // 테마 강제: true=라이트 / false=다크 / 미지정=앱 테마 따름
    light: { type: Boolean, default: undefined },
  },
  computed: {
    isDark() {
      if (typeof this.light === "boolean") return !this.light;
      return this.$vuetify.theme.dark;
    },
  },
  methods: {
    onSelect(it) {
      if (it.disabled) return;
      this.$emit("select", it.value != null ? it.value : it);
    },
  },
};
</script>
